import DapDSPasswordInput from './password-input.component'

export * from './password-input.component'
export default DapDSPasswordInput

DapDSPasswordInput.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-password-input': DapDSPasswordInput
  }
}
